import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider } from 'antd';
import { SubmitButton } from 'formik-antd';
import { useHistory } from 'react-router-dom';
import Client from 'containers/app/client';
import './style.css';

const FormActions = ({ onBack, isSubmitting, showSaveLater, showLogout }) => {
  const history = useHistory();

  return (
    <>
      <Divider />
      <div className="form-actions">
        {showLogout ? (
          <>
            <Button
              size="large"
              onClick={() => {
                Client.auth.signOut();
                history.push('/');
              }}
            >
              Logout
            </Button>
          </>
        ) : (
          <>
            {showSaveLater && onBack != null ? (
              <Button size="large" onClick={onBack}>
                Save and continue later
              </Button>
            ) : null}
            <SubmitButton
              type="primary"
              size="large"
              disabled={isSubmitting}
              loading={isSubmitting}
            >
              Continue
            </SubmitButton>
          </>
        )}
      </div>
    </>
  );
};

FormActions.propTypes = {
  onBack: PropTypes.func,
  isSubmitting: PropTypes.bool,
  showLogout: PropTypes.bool,
  showSaveLater: PropTypes.bool,
};

FormActions.defaultProps = {
  onBack: null,
  isSubmitting: false,
  showLogout: false,
  showSaveLater: true,
};

export default FormActions;
